import styled from '@emotion/styled'

const LABEL_WIDTH = '50%'

export const ColumnsContainer = styled.div`
  max-height: 500px;
  min-width: 420px;
  overflow-y: auto;
  padding: 0 6px;

  & > * {
    margin: 3px 0;
  }

  label {
    width: ${LABEL_WIDTH};
  }
`

export const ColumnsHeaderPanel = styled.div`
  display: flex;
  margin-bottom: 6px;
`

export const ColumnsHeader = styled.span`
  font-weight: bold;
  &:first-child {
    flex: 0 0 calc(${LABEL_WIDTH} + 10px);
  }
`
